export * from './chart'
export * from './date'
export * from './format'
export * from './badge'
export * from './export'

// Import cn function directly
import { cn } from './cn'
export { cn }

/**
 * Parse input string with flexible separators (comma, semicolon, newline)
 * @param input - Input string to parse
 * @returns Array of trimmed strings
 */
export const parseFlexibleInput = (input: string): string[] => {
  if (!input || input.trim() === '') {
    return []
  }
  
  // Split by comma, semicolon, or newline, then filter out empty strings and trim
  return input
    .split(/[,;\n]/)
    .map(item => item.trim())
    .filter(item => item.length > 0)
}

/**
 * Format array back to display string
 * @param items - Array of strings
 * @returns Formatted string with commas
 */
export const formatArrayToDisplay = (items: string[]): string => {
  return items.join(', ')
} 